import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SummaryService {
    constructor(private readonly httpClient: HttpClient) { }

    getSummary(): Observable<any> {
        let params = new HttpParams();
        return this.httpClient.get(
            `${environment.apiUrl}/view/current-status`, { params: params }
        );
    }
    
    getAnnualSummary(): Observable<any> {
        let params = new HttpParams();
        return this.httpClient.get(
            `${environment.apiUrl}/view/year_summary_full`, { params: params }
        );
    }
}